(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var sectionSelectors = [
    'body.template-index [id$="__163247026462da6862"]',
    'body.template-index [id$="__product_block_r4EmHh"]'
  ];

  function sectionQuery(selector) {
    return sectionSelectors.map(function (section) {
      return section + ' ' + selector;
    }).join(',');
  }

  function getTargetSections() {
    return sectionSelectors.map(function (section) {
      return document.querySelector(section);
    }).filter(Boolean);
  }

  function normalizeSectionHeading(text) {
    var value = text.replace(/\s+/g, ' ').trim();
    var headings = {
      'NEW ARRIVALS': 'New Arrivals',
      'HOT SELLERS': 'Hot Sellers'
    };

    return headings[value] || value;
  }

  function cleanProductTitles() {
    if (!document.body.classList.contains('template-index') || !mobileQuery.matches) {
      return;
    }

    document.querySelectorAll(sectionQuery('.halo-block-header .title .text')).forEach(function (heading) {
      var normalized = normalizeSectionHeading(heading.textContent);

      if (heading.textContent.trim() !== normalized) {
        heading.textContent = normalized;
      }
    });

    document.querySelectorAll(sectionQuery('.card-title')).forEach(function (titleLink) {
      // Keep the model/specification layers rendered by the shared card snippet.
      if (titleLink.querySelector('.olitans-card-title__name')) return;
      var productTitle = titleLink.getAttribute('data-product-title');

      if (productTitle) {
        productTitle = productTitle.replace(/\s+/g, ' ').trim();

        if (titleLink.textContent.replace(/\s+/g, ' ').trim() !== productTitle) {
          titleLink.textContent = productTitle;
        }

        titleLink.setAttribute('title', productTitle);
      } else {
        titleLink.querySelectorAll('[data-change-title]').forEach(function (variantText) {
          variantText.remove();
        });
      }

      titleLink.style.textTransform = 'none';
      titleLink.style.letterSpacing = '0';
    });
  }

  var scheduled = false;

  function scheduleClean() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      cleanProductTitles();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    cleanProductTitles();

    getTargetSections().forEach(function (section) {
      new MutationObserver(scheduleClean).observe(section, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  });

  window.addEventListener('resize', scheduleClean);
  document.addEventListener('shopify:section:load', scheduleClean);
  setTimeout(scheduleClean, 500);
  setTimeout(scheduleClean, 1500);
}());
